import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';

/**
 * Missing-required-field warnings are computed from the container's current state, so they are hidden in
 * exports and print previews.
 */
export default function useShowMissingRequiredFieldWarnings(): boolean {
  const {isExportView, isPrintPreviewView} = EditorPropertiesContext.useContext();
  return !isExportView && !isPrintPreviewView;
}
